<template>
  <div class="caddress">
    <baidu-map class="map" :center="{lng: 112.8228, lat: 28.2434}" :zoom="15">
      <bm-marker :position="{lng: 112.8228, lat: 28.2434}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      </bm-marker>
    </baidu-map>
    <div class="caddress-right">
      <div class="caddress-concat">
        <img src="../assets/icon_lxwm.png" class="caddress-concat-icon"/>
        <div class="caddress-concat-text">联系我们</div>
      </div>
      <div class="caddress-concat-content">
        <p>联系人：谈树根</p>
        <p>电&nbsp;&nbsp;&nbsp;话：0731-88926492</p>
        <p>地&nbsp;&nbsp;&nbsp;址：长沙高新开发区岳麓西大道2450号环创园A4栋605</p>
      </div>
      <div class="caddress-concat2">
        <img src="../assets/icon_jltd.png" class="caddress-concat-icon"/>
        <div class="caddress-concat-text">简历投递</div>
      </div>
      <div class="caddress-concat-content">
        <p>邮&nbsp;&nbsp;&nbsp;箱：vip@tanner-china.com</p>
      </div>
    </div>
  </div>
</template>

<script>
  import BaiduMap from 'vue-baidu-map/components/map/Map.vue'

  export default {
    name: "CAddress",
    components: {BaiduMap},
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>
  .caddress {
    width: 1070px;
    margin: 43px auto 106px;
    display: flex;
    align-items: center;
  }

  .map {
    width: 605px;
    height: 307px;
    background: #F4F6F8;
    box-shadow: 0px 8px 24px 0px rgba(0, 1, 59, 0.1);
    border-radius: 6px;
    border: 4px solid #fff;
  }

  .caddress-right {
    margin-left: 81px;
  }

  .caddress-concat {
    display: flex;
  }
  .caddress-concat2{
    display: flex;
    margin-top: 44px;
  }

  .caddress-concat-icon {
    width: 31px;
    height: 31px;
  }

  .caddress-concat-text {
    margin-left: 5px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4A4A4A;
    line-height: 29px;
  }

  .caddress-concat-content {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9B9B;
    line-height: 28px;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CAddress.vue